import React from 'react'
import { Pagination } from 'antd'
import { styled } from 'troyfe'

/**
 *
 * @param {{
 * total: Number,
 * current: Number,
 * pageSize: Number
 * }} props {
 * total: 数据总数,
 * current: 当前页数,
 * pageSize: 每页条数
 * }
 *
 * @returns
 */

export default function CustomizingPagination({
  total,
  current,
  pageSize = 10,
  ...defaultProps
}) {
  const pageProps = {
    total,
    showTotal: total => `共 ${total} 条`,
    pageSize,
    showSizeChanger: true,
    showQuickJumper: true,
    current,
    ...defaultProps
  }
  return <PageWarpper {...pageProps} />
}

const PageWarpper = styled(Pagination)`
  text-align: right;
`
